import { render, staticRenderFns } from "./TextForNextReport.vue?vue&type=template&id=4d679a0a&scoped=true&lang=html&"
import script from "./TextForNextReport.vue?vue&type=script&lang=coffee&"
export * from "./TextForNextReport.vue?vue&type=script&lang=coffee&"
import style0 from "./TextForNextReport.vue?vue&type=style&index=0&id=4d679a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d679a0a",
  null
  
)

component.options.__file = "TextForNextReport.vue"
export default component.exports